import { render, staticRenderFns } from "./AsignacionEquipoSubsede.vue?vue&type=template&id=49bf8ebd"
import script from "./AsignacionEquipoSubsede.vue?vue&type=script&lang=js"
export * from "./AsignacionEquipoSubsede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports